import { createBaseApi, getAuthHeaders } from '../utils/baseApi';

const apiVersion = 'v1';

const { getJson, postJson, deleteJson, putJson } = createBaseApi(`/api/${apiVersion}`, { headers: getAuthHeaders });

export const getItemsForPolicy = (id, insuredId, include, filter, pageData) => getJson(`/policies/${id}/items`, { insured_id: insuredId }, pageData, { filter }, { include });

export const updatePolicy = (policyId, policyData) => putJson(`/policies/${policyId}`, policyData);

export const reactivatePolicy = ({ policyId, recordId }) => putJson(`/policies/${policyId}/reactivate`, { record_id: recordId });

export const archivePolicy = ({ policyId, recordId }) => putJson(`/policies/${policyId}/archive`, { record_id: recordId });

export const deletePolicy = ({ policyId, recordId }) => deleteJson(`/policies/${policyId}`, { record_id: recordId });

export const getPolicyType = policyTypeId => getJson(`/insurance-policy-types/${policyTypeId}`);

export const getPolicyAgent = policyId => getJson(`/policies/${policyId}/agents`);

